import { URLS, HTTP_METHODS, HEADERS_CONTENT_TYPE } from 'modules/api/constants';
import handleRequest from 'modules/api/common';
import { CancelFunctions } from 'components/common/types';
import {
  DirectSalesProductTemplateRequest,
  ProductTemplateResponse,
  DirectSalesProductTemplateResponse,
} from 'components/common/types/DirectSalesProductTemplate.types';

export const createDirectSalesProductTemplate = (
  data: Partial<DirectSalesProductTemplateRequest>,
  marketId: string,
  cancelFunctions: CancelFunctions,
): Promise<DirectSalesProductTemplateResponse> => {
  const reqOptions = {
    url: URLS().CREATE_DIRECT_SALES_PRODUCT_TEMPLATE(marketId),
    method: HTTP_METHODS.POST,
    data,
    headers: {
      'Content-Type': HEADERS_CONTENT_TYPE.APPLICATION_JSON,
    },
    notificationTimeout: 0,
  };

  return handleRequest(reqOptions, cancelFunctions, 'CREATE_DIRECT_SALES_PRODUCT_TEMPLATE');
};

export const fetchDirectSalesProduct = (
  marketId: string,
  cancelFunctions: CancelFunctions,
  productId: string,
): Promise<ProductTemplateResponse> => {
  const reqOptions = {
    url: URLS().FETCH_DIRECT_SALES_PRODUCT(marketId, productId),
    method: HTTP_METHODS.GET,
    headers: {
      'Content-Type': HEADERS_CONTENT_TYPE.APPLICATION_JSON,
    },
  };

  return handleRequest(reqOptions, cancelFunctions, `FETCH_DIRECT_SALES_PRODUCT_${productId}`);
};

export const fetchDirectSalesProductList = (
  marketId: string,
  cancelFunctions: CancelFunctions,
): Promise<ProductTemplateResponse[]> => {
  const reqOptions = {
    url: URLS().FETCH_DIRECT_SALES_ALL_PRODUCT_LIST(marketId),
    method: HTTP_METHODS.GET,
    headers: {
      'Content-Type': HEADERS_CONTENT_TYPE.APPLICATION_JSON,
    },
    ignoreNotifyError: true,
  };

  return handleRequest(reqOptions, cancelFunctions, 'FETCH_DIRECT_SALES_ALL_PRODUCT_LIST');
};

export const fetchDirectSalesFilteredProductList = (
  marketId: string,
  cancelFunctions: CancelFunctions,
  query: string,
): Promise<ProductTemplateResponse[]> => {
  const reqOptions = {
    url: URLS().FETCH_DIRECT_SALES_FILTERED_PRODUCT_LIST(marketId, query),
    method: HTTP_METHODS.GET,
    headers: {
      'Content-Type': HEADERS_CONTENT_TYPE.APPLICATION_JSON,
    },
  };

  return handleRequest(reqOptions, cancelFunctions, 'FETCH_DIRECT_SALES_FILTERED_PRODUCT_LIST');
};

export const fetchDirectSalesProductFolder = (
  marketId: string,
  cancelFunctions: CancelFunctions,
): Promise<{ folder: string }[]> => {
  const reqOptions = {
    url: URLS().FETCH_DIRECT_SALES_PRODUCT_FOLDER(marketId),
    method: HTTP_METHODS.GET,
    headers: {
      'Content-Type': HEADERS_CONTENT_TYPE.APPLICATION_JSON,
    },
  };

  return handleRequest(reqOptions, cancelFunctions, 'FETCH_DIRECT_SALES_PRODUCT_FOLDER');
};

export const toggleDirectSalesProductStatus = (
  data: { status: 'Disabled' | 'Active' },
  marketId: string,
  productId: string,
  cancelFunctions: CancelFunctions,
): Promise<ProductTemplateResponse> => {
  const reqOptions = {
    url: URLS().TOGGLE_DIRECT_SALES_PRODUCT_STATUS(marketId, productId),
    method: HTTP_METHODS.PATCH,
    data,
    headers: {
      'Content-Type': HEADERS_CONTENT_TYPE.APPLICATION_JSON,
    },
  };

  return handleRequest(reqOptions, cancelFunctions, 'TOGGLE_DIRECT_SALES_PRODUCT_STATUS');
};
